export function getTableHeaderUnilateral(state) {
  return state.tableHeaderUnilateral;
}
